export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const SET_DATA_CHILD = (state, { id, data, child }) => {
  state[id][child] = data;
};
export const checkHasBio = (state, value) => {
  state.hasBio = value;
};
export const CLEAR_BIO = (state, value) => {
  state.bio = {
    fullname: "",
    img: "",
    about: "",
    national_number: "",
    jobPos: "",
    workPlace: "",
    imgSrc: "",
    phonenumber: "",
    instagram: "",
    twitter: "",
    facebook: "",
    telegram: "",
    website: "",
    bank_account_number: "",
    credit_card_number: "",
    bank_name: ""
  };
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/profile/mutations.js